import React from "react";

import { useTheme } from "@mui/material/styles";

// import { GetAuthData } from "contexts/TAuthContext";
import { isObjectEmpty } from "@data/functions";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  getLocalStorageItem,
  isIdentical,
  joinParams,
  setLocalStorageItem,
} from "data/functions";
import { getUA } from "data/functions";
import { actions } from "data/globals";
import { ChannelsContext, ChannelsProvider } from "./ChannelsContext";
import { CodeProvider } from "./CodeContext";
import { CompanyProvider } from "./CompanyContext";
export const DataContext = React.createContext();
// const initState = {
//   token: "",
//   setState: setToken,
// };

function clear(state) {
  let obj = {};
  if (!isObjectEmpty(state.dataObj?.deviceWidth))
    obj["deviceWidth"] = state.dataObj?.deviceWidth;
  if (!isObjectEmpty(state.dataObj?.pin)) obj["pin"] = state.dataObj?.pin;
  if (!isObjectEmpty(state.dataObj?.usedEquipment))
    obj["usedEquipment"] = state.dataObj?.usedEquipment;
  let keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    let key = localStorage.key(i);
    if (key.includes("data_")) {
      keys = [...keys, key];
    }
  }
  keys.forEach((el) => {
    localStorage.removeItem(el);
  });

  return obj;
}

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.clearArray: {
      let obj = clear(state);
      if (!isIdentical(state?.dataObj, obj)) return { ...state, dataObj: obj };
      else return state;
    }
    case actions.pushArray: {
      let stateValue = state?.dataObj[action.paramName];
      let newValue = joinParams(stateValue, action.paramValue, action.defType);

      if (!isIdentical(stateValue, newValue)) {
        setLocalStorageItem("data_" + action.paramName, newValue);
        return {
          ...state,
          dataObj: {
            ...state.dataObj,
            [action.paramName]: newValue,
          },
        };
      } else return state;
    }
    case actions.resetCache: {
      let obj = clear(state);
      if (!isIdentical(state?.dataObj, obj)) return { ...state, dataObj: obj };
      else return state;
    }
    case actions.setArray: {
      let paramValue = state?.dataObj[action.paramName];

      if (!isIdentical(paramValue, action.paramValue)) {
        setLocalStorageItem("data_" + action.paramName, action.paramValue);
        return {
          ...state,
          dataObj: {
            ...state?.dataObj,
            [action.paramName]: action.paramValue,
          },
        };
      } else return state;
    }
    case actions.forceSet: {
      if (!action.paramName) return state;

      try {
        setLocalStorageItem("data_" + action.paramName, action.paramValue);
        return {
          ...state,
          dataObj: {
            ...state?.dataObj,
            [action.paramName]: action.paramValue,
          },
        };
      } catch (e) {
        return state;
      }
    }
    default:
      return state;
  }
};

export const initialState = {
  dataObj: {},
};

export function CheckSize(theme) {
  return useMediaQuery(theme.breakpoints.up("md"));
}

function DataProvider({ children }) {
  const theme = useTheme();
  // const { token, setLogined, isLogined } = GetAuthData();
  const [state, dispatch] = React.useReducer(reducer, initialState);

  let greaterThanMid = useMediaQuery(theme.breakpoints.up("md"), {
    noSsr: true,
  });
  let greaterThanLg = useMediaQuery(theme.breakpoints.up("lg"), {
    noSsr: true,
  });

  const value = {
    clearCache: React.useCallback(
      () =>
        dispatch({
          type: actions.resetCache,
        }),
      []
    ),
    clearDataObj: React.useCallback(
      () =>
        dispatch({
          type: actions.clearArray,
        }),
      []
    ),
    dataObj: state.dataObj,
    forceSetDataObj: React.useCallback(
      (value, param, findParam, findVal) =>
        dispatch({
          findParam: findParam,
          findValue: findVal,
          paramName: param,
          paramValue: value,
          type: actions.forceSet,
        }),
      []
    ),
    pushDataObj: React.useCallback(
      (value, param, defType = {}) =>
        dispatch({
          defType: defType,
          paramName: param,
          paramValue: value,
          type: actions.pushArray,
        }),
      []
    ),
    setDataObj: React.useCallback(
      (value, param) =>
        dispatch({
          paramName: param,
          paramValue: value,
          type: actions.setArray,
        }),
      []
    ),
  };

  React.useEffect(() => {
    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i);
      let value = undefined;
      try {
        value = getLocalStorageItem(key);
        if (
          !isObjectEmpty(value) &&
          key.includes("data_")
          // && !key.includes("folderList") &&
          // !key.includes("serviceList")
        ) {
          dispatch({
            paramName: key.replace("data_", ""),
            paramValue: value,
            type: actions.setArray,
          });
        }
      } catch {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let mobile = greaterThanMid ? false : true;
    let pad = !greaterThanLg && greaterThanMid ? true : false;
    if (
      !isIdentical(mobile, state?.dataObj?.deviceWidth?.isMobile) ||
      !isIdentical(pad, state?.dataObj?.deviceWidth?.isPad)
    ) {
      dispatch({
        defType: {},
        paramName: "deviceWidth",
        paramValue: { isMobile: mobile, isPad: pad },
        type: actions.pushArray,
      });
    }
  }, [greaterThanMid, greaterThanLg]);

  React.useEffect(() => {
    dispatch({
      paramName: "platform",
      paramValue: getUA(),
      type: actions.setArray,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigator.userAgent]);

  return (
    <DataContext.Provider value={value}>
      <ChannelsProvider>
        <CompanyProvider>
          <CodeProvider>{children}</CodeProvider>
        </CompanyProvider>
      </ChannelsProvider>
    </DataContext.Provider>
  );
}
export const GetData = () => {
  const context = React.useContext(DataContext);
  return context;
};

export { DataProvider };
